/**
 * @ignore  =====================================================================================
 * @class   IncidentsPage
 * @version 1.0.0
 * @author  Damon Liu(damon.liu@everbridge.com)
 * @date    Created at 4:05 PM 26/03/2018
 * @ignore  =====================================================================================
 */

import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'commons';
import { loadRemoteManifest, redirectToLogin } from 'utils';
import { ajaxLoading } from 'utils/Ajax';

const resizeIFrame = obj => {
  if (!obj) {
    return;
  }
  const iFrame = obj;
  iFrame.style.height = 0;
  const height =
    window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  iFrame.style.height = `${height - 290}px`;
};

const listenWindowResize = () => {
  resizeIFrame(document.getElementById('incidentContainerIFrame'));
};

let rootHeight = null;

const IncidentsPage = () => {
  const { account: { id: accountId }, organization: { enableReceiptTranscripts }, featureToggle } = useContext(GlobalContext);
  const [IncidentContainerComponent, setIncidentContainerComponent] = useState();

  useEffect(() => {
    if (accountId === 0) {
      redirectToLogin();
    }

    window.addEventListener('resize', listenWindowResize);
    const url = `/static_mbr_incident_chat/IncidentChat/manifest.json?t=${Math.random()}`
    ajaxLoading.show();
    loadRemoteManifest({
      url,
      callback: component => {
        ajaxLoading.show();
        setIncidentContainerComponent(component);
      },
    });

    return () => {
      window.removeEventListener('resize', listenWindowResize);
    };
  }, []);

  useEffect(() => {
    if (IncidentContainerComponent) {
      ajaxLoading.show();
      setTimeout(() => {
        ajaxLoading.hide();
      }, 1500);
    }
  }, [IncidentContainerComponent]);

  if (!IncidentContainerComponent) {
    return null;
  }

  if (rootHeight === null) {
    rootHeight = document.getElementById('root').offsetHeight;
  }
  return (
    <div className="container">
      <div
        className="well ssp-well incidents-box"
        style={{
          height: `calc(100vh - ${rootHeight}px)`,
        }}
      >
        <IncidentContainerComponent {...{ enableReceiptTranscripts, featureToggle }} />
      </div>
    </div>
  );
};

export default IncidentsPage;
